import FeedbackTour from 'src/components/FeedbackTour/FeedbackTour';
import { capitalizeFirstLetter } from 'src/utils/string';

const EstatisticasPageSteps = (
  intl,
  resources,
  jaExisteFeedback,
  isLoadingFeedback
) => {
  const feature = {
    id: 7,
    descricao: 'estatisticas',
  };

  return [
    {
      selector: '.iniciando-tour',
      content: capitalizeFirstLetter(
        intl.formatMessage({ id: 'iniciandoTour' })
      ),
      position: [20, 20],
    },
    {
      selector: '.estatisticas-step1',
      content: capitalizeFirstLetter(
        intl.formatMessage({ id: 'apliqueFiltrosEstatistica' })
      ),
    },
    {
      selector: '.estatisticas-step2',
      content: capitalizeFirstLetter(
        intl.formatMessage({ id: 'cliqueNasColunas' })
      ),
    },
    {
      selector: '.estatisticas-step3',
      content: capitalizeFirstLetter(
        intl.formatMessage({ id: 'selecioneExportacao' })
      ),
    },
   
    ...(jaExisteFeedback
      ? []
      : [
          {
            selector: '.dash-feedback',
            content: (
              <FeedbackTour
                feature={feature}
                intl={intl}
                isLoadingFeedback={isLoadingFeedback}
              />
            ),
            position: 'center',
          },
        ]),
  ];
};

export default EstatisticasPageSteps;
